export default {
  name: 'marking--markingType',
};